import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
class StateOrgUnitTabDialog {
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck() {
        return null;
    }
}
export default StateOrgUnitTabDialog;